/**
 * Indian-style number/currency formatter — same convention as Daewoo's app.
 *   1234567 → 12,34,567
 *   1234567.89 → 12,34,567.89
 */
export function formatIndianNumber(n) {
    if (n === null || n === undefined || n === '') return '0';
    const num = Number(n);
    if (Number.isNaN(num)) return '0';
    const [intPart, decPart] = Math.abs(num).toFixed(2).split('.');
    let lastThree = intPart.slice(-3);
    const rest = intPart.slice(0, -3);
    if (rest) lastThree = ',' + lastThree;
    const formatted = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    const showDec = decPart && decPart !== '00';
    return (num < 0 ? '-' : '') + formatted + (showDec ? '.' + decPart : '');
}
export const inr = (n) => '₹' + formatIndianNumber(n);

/**
 * Single, app-wide collection-percentage formatter so the same client never
 * shows a different % on two screens. Always 1 decimal place (e.g. "12.7%").
 * Pass the server-computed receivedPercent (totalReceived / finalPayable).
 */
export function fmtPct(n) {
    const num = Number(n);
    if (!Number.isFinite(num)) return '0.0%';
    return `${num.toFixed(1)}%`;
}
